/*
 * Copyright (c) 2022, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import {
  start,
  registerServiceWorker
} from '@salesforce/pwa-kit-react-sdk/ssr/browser/main'

const main = () => {
  if (window && window.parent) {
    setTimeout(function () {
      var height = document.getElementsByTagName('html')[0].scrollHeight
      window.parent.postMessage(['heightForIFrame', height], '*')
    }, 1000)
  }

  // The path to your service worker should match what is set up in ssr.js
  return Promise.all([start(), registerServiceWorker('/worker.js')])
}

main()
